const getFilterData = state  => state.filterData;
const isFilterLoading = state  => state.isFilterLoading;

const getAzureInventoryList = state  => state.inventoryList;
const isAzureInventoryListLoading = state => state.isAzureInventoryListLoading;


export default {
  getFilterData,
  isFilterLoading,
  getAzureInventoryList,
  isAzureInventoryListLoading
};



// WEBPACK FOOTER //
// ./src/store/modules/azure-reserved/azure-inventory/getters.js